export const sizeData = [
    {
      code: ".img- * (70/80/90/100)",
      text: "Using ",
    },
    {
      text: " class you can set the size of avatar",
    },
  ];
  
  export const sizeImages = [
    {
      className: "img-90",
      src: "2.jpg",
      size: 90,
    },
    {
      className: "img-80",
      src: "3.jpg",
      size: 80,
    },
    {
      className: "img-70",
      src: "4.jpg",
      size: 70,
    },
  ];
  
  export const statusData = [
    {
      code: " .status-* (online/offline/dnd) ",
      text: "Using ",
    },
    {
      text: " class you can set status of avatar.",
    },
  ];
  
  export const statusIndicators = [
    {
      className: "img-90",
      src: "4.jpg",
      size: 90,
      color: "warning",
    },
    {
      className: "img-80",
      src: "5.jpg",
      size: 80,
      color: "danger",
    },
    {
      className: "img-70",
      src: "2.jpg",
      size: 70,
      color: "success",
    },
  ];
  
  export const shapeData = [
    {
      code: " .b-r-* (8/30/35/25)",
      text: "Using the",
    },
    {
      text: " class you can set the shapes of avatar.",
    },
  ];
  
  export const shape = [
    {
      className: "img-90",
      src: "5.jpg",
      size: 90,
    },
    {
      className: "img-80",
      src: "6.jpg",
      size: 80,
    },
    {
      className: "img-70",
      src: "7.jpg",
      size: 70,
    },
  ];
  
  export const ratioData = [
    {
      code: ".ratio",
      text: "Give the shape to avatar using ",
    },
    {
      code: " img-* (50/70/80/90/100) ",
      text: " and ",
    },
    {
      text: " class.",
    },
  ];
  
  export const ratios = [
    {
      className: "img-90",
      src: "avatar/5.jpg",
      size: 90,
    },
    {
      className: "img-80",
      src: "avatar/1.jpg",
      size: 80,
    },
    {
      className: "img-70",
      src: "avatar/7.jpg",
      size: 70,
    }
  ];
  
  export const groupingData = [
    {
      code: ".img-* (40/50/60/80/100) ",
      text: "You can set the group of avatars like ",
    },
    {
      code: ".b-r-* (8/30/35).",
      text: "class. ",
    },
  ];
  
  export const groupingImageOne = [
    {
      className: "img-80 b-r-30",
      src: "avatar/5.jpg",
    },
    {
      className: "img-50 b-r-35",
      src: "avatar/7.jpg",
    },
  ];
  
  export const groupingImageTwo = [
    {
      className: "b-r-8 img-80",
      src: "avatar/6.jpg",
      size: 76,
    },
    {
      className: "img-60 rounded-circle",
      src: "avatar/8.jpg",
      size: 56,
    },
  ];
  
  export const groupingImageThird = ["avatar/5.jpg", "avatar/8.jpg"];

  export const groupingWithCounter = [
    {
      text:"Set the group with counter",
      code:".img-* , .b-r-*"
    },
    {
      text:"class."
    }
  ]

  export const groupingWithCounterData = [
    "5","6"
  ]